// `calls.opened` / `calls.updated` / `calls.closed` on `venue:{id}:calls` (spec/09 §3, §6.3; F-SES-25).
//
// The live push for calls for help: a call raised, answered, resolved, cancelled or expired reaches
// the console's floor and its "What needs you" panel (spec/13 §3.2). Each frame carries the whole call
// (its station, player, category, note, state and the staff member on the way), so the panel applies it
// to the card it already shows without a refetch. A member subscribes to `venue:{id}:calls` only with
// `calls:read` (the gateway checks it, spec/09 §3); the REST list (`GET …/venues/{v}/calls`) is the
// recovery mechanism (spec/09 §4).
//
// The frames ride the outbox dispatcher's realtime sink (`sessions/realtime.ts`), not the gateway's
// floor coalescer, so they carry no per-channel `version` yet — the follow-on shared with the floor's
// counter. The station client (C#) does not read these — they are a console/app message — so they are
// not in `REALTIME_JSON_SCHEMAS`.
import { z } from "../zod.js";
import { StationCallSchema } from "../routes/calls.js";
import { CALLS_CLOSED, CALLS_OPENED, CALLS_UPDATED } from "./constants.js";
import { realtimeMessage } from "./envelope.js";
export { CALLS_CLOSED, CALLS_OPENED, CALLS_UPDATED };
/** The payload all three frames carry: the call as the panel renders it (spec/09 §6.3). */
export const CallEventPayloadSchema = z
    .object({ call: StationCallSchema })
    .openapi('CallEventPayload', {
    description: 'A call for help changed: the whole call, to apply to the floor and "What needs you" (spec/09 §6.3).',
});
/** A player raised a call (spec/05 §11). */
export const CallOpenedMessage = realtimeMessage('evt', CALLS_OPENED, CallEventPayloadSchema);
/** A call was answered — "On my way" (spec/05 §11). */
export const CallUpdatedMessage = realtimeMessage('evt', CALLS_UPDATED, CallEventPayloadSchema);
/** A call closed — resolved, cancelled or expired (spec/05 §11). */
export const CallClosedMessage = realtimeMessage('evt', CALLS_CLOSED, CallEventPayloadSchema);
//# sourceMappingURL=calls.js.map